export var EVO_EMAIL = /^(?!.*evolus\.com.*).*$/;
